$(function(){
    sizeGuideTab();
  });

sizeGuideTab = () =>{
  $('.jsc-tab-header-size .button').click(function(e){
    var $this = $(e.target);
    var $dataAttr = $this.attr('data-content');
    var $contentContainer = $('.jsc-tab-content-size');
    var $headerContainer = $('.jsc-tab-header-size');

    // update tab header btn
    $headerContainer.children().removeClass('jsc-active-btn');
    $headerContainer.find('a[data-content="'+ $dataAttr +'"]').addClass('jsc-active-btn');

    // update tab content 
    $contentContainer.children().hide();
    $contentContainer.find('.'+$dataAttr).show();
  });
}
